import React from 'react';
import {View} from 'react-native';

import {createSubNavigator} from '../../components/SubNavigator';
import Dashboard from "./Dashboard";
import Customers from './Customers';
import Reviews from './Reviews';
import Team from './Team';
import Markets from './Markets';
import Inbox from './Inbox';
import {basicStyles} from '../../styles/basic';
import {connect} from "react-redux";

const SubNavigator = createSubNavigator();

function Reports(props) {
	const organization = props.auth.organization;
	const isInboxEnabled = organization
		&& organization.organization_message_flow_active == 1
		&& (
			(
				organization.organization_textline_enabled
				&& organization.organization_textline_token
				&& organization.organization_textline_group_uuid
			)
			||
			(
				organization.organization_twilio_enabled
				&& organization.organization_twilio_token
				&& organization.organization_twilio_sid
				&& organization.organization_twilio_service_sid
			)
		);

	return (
		<View style={basicStyles.flexScale}>
			<SubNavigator.Navigator backbehavior="history">
				<SubNavigator.Screen
					name="Dashboard"
					component={Dashboard}
					options={{
						title: 'Dashboard'
					}}
				/>
				{/*<SubNavigator.Screen*/}
				{/*	name="Customers"*/}
				{/*	component={Customers}*/}
				{/*	options={{*/}
				{/*		title: 'Customers'*/}
				{/*	}}*/}
				{/*/>*/}
				{
					props.auth.permissions.includes('view_account_reports') ?
						<>
							<SubNavigator.Screen
								name="Reviews"
								component={Reviews}
								options={{
									title: 'Reviews'
								}}
							/>
							<SubNavigator.Screen
								name="Markets"
								component={Markets}
								options={{
									title: 'Markets'
								}}
							/>
							<SubNavigator.Screen
								name="Team"
								component={Team}
								options={{
									title: 'Team'
								}}
							/>
							{
								props.auth.permissions.includes('access_messageflow') && isInboxEnabled ?
									<SubNavigator.Screen
										name="Inbox"
										component={Inbox}
										options={{
											title: 'Inbox'
										}}
									/>
									: null
							}
						</>
						: null
				}
			</SubNavigator.Navigator>
		</View>
	);
}

const mapStateToProps = (state) => {
	const {auth} = state;
	return {auth};
};

export default connect(mapStateToProps)(Reports);
